import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-detail-title',
    templateUrl: './detail-title.component.html',
    styleUrls: ['./detail-title.component.scss'],
    standalone: false,
})
export class DetailTitleComponent {
    @Input()
    public title?: string;
}
